
















































































































































































import { CreateElement } from "vue"
import { Vue, Component } from "vue-property-decorator"
import { mapGetters } from "vuex"
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import AddUserVue from "@/components/User/AddUser.vue"
import SetPasswordVue from "@/components/User/SetPassword.vue"
import EditAreaVue from "@/components/User/EditArea.vue"
import AccounterImportVue from "../components/app/AccounterImport.vue";

@Component({
    ...mapGetters(["account", "searchKey"]),
    components: {
        // addUser,
        // setPassword,
        // editArea,
        "user-tree": AllUserTreeVue,
        "add-user": AddUserVue,
        "edit-area": EditAreaVue,
        "set-pwd": SetPasswordVue,
        AccounterImport: AccounterImportVue,
    }
})
export default class user extends Vue {
    //模态框显示
    showAdd: boolean = false;
    userTitle: string = "新增员工";
    showPwd: boolean = false;
    showArea: boolean = false;

    tmp: UserTree | null = null;

    //右侧详细表格
    accounter: Account | null = null;
    specify: Account[] = [];
    userData: Account | null = null;

    currentPage: number = 1;
    pageSize: number = 13;
    totalElements: number = 0;
    loginId: string = ""

    mounted() {
        let name = localStorage.getItem("loginId")
        if (name) this.loginId = name
    }

    fetchData(no?: string) {
        no = no ? no : this.$store.state.account.no;
        Vue.axios.post("accounts/findmyallaccounters?page=" + (this.currentPage - 1) + "&size=" + this.pageSize + "&searchKey=" + this.$store.state.searchKey + "&accounterNo=" + no).then(response => {
            this.specify = Object.freeze(response.data.content);
            this.totalElements = Object.freeze(response.data.totalElements);
        })
    }

    // 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
    treeExpand(data: UserTree) {
        this.tmp = data;
    }
    // 点击tree中的名字(node)
    handleNodeClick(data: Account) {
        this.accounter = data;
        // this.$store.state.searchKey = "";
        this.currentPage = 1;
        this.$store.dispatch("clearSearchKey");
        this.fetchData(data.no);
    }

    // 打开区域管理dialog
    showAreaModal() {
        this.showArea = true;
    }
    // 打开添加/新增用户dialog
    showAddUser() {
        this.userTitle = "新增员工";
        this.userData = null;
        this.showAdd = true;
    }

    changePage(val: number) {
        this.currentPage = val;
        if (this.accounter != null)
            this.fetchData(this.accounter.no);
    }

    //编辑用户
    editUser(data: Account) {
        this.userTitle = "编辑员工";
        this.userData = data;
        if (data.id != this.$store.state.account.id || data.role ==="管理员")
            this.showAdd = true;
    }
    // 设置密码
    setPwd(data: Account) {
        this.userData = data;
        this.showPwd = true;
    }
    // 关闭新增/编辑用户dialog
    closeAdd(val: boolean, changed: boolean) {
        let addDialog = <AddUserVue>this.$refs.addUser;
        addDialog.resetForm();
        this.showAdd = false;
        if (val && this.accounter != null && this.tmp != null) {
            let tree = <AllUserTreeVue>this.$refs.userTree;
            tree.nodeExpand(this.tmp);
            this.fetchData(this.accounter.no);
            if (changed) {
                let userTree = (<AllUserTreeVue>this.$refs.userTree);
                userTree.getUsers();
            }
        }
    }

    closePwd() {
        this.showPwd = false;
    }

    //点击删除
    deleteUser(data: Account) {
        if (this.$store.state.accountBook.no == data.no) {
            this.$message({
                type: "success",
                message: "亲，无法删除自己！"
            })
        } else {
            this.$confirm("确定要删除员工：" + data.name + "吗？", "温馨提示", {
                type: "warning",
                callback: (action: string) => {
                    if (action == "confirm") {
                        Vue.axios.post("accounts/delete", data).then(response => {
                            let userTree = (<AllUserTreeVue>this.$refs.userTree);
                            userTree.getUsers();
                            if (this.accounter != null) this.fetchData(this.accounter.no)
                        })
                    }
                }
            })
        }
    }
    AccounterImport: boolean = false;
    accountImport() {
        this.AccounterImport = !this.AccounterImport;
    }
}
